<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-header">
        <div class="header-title">
          <span>EDIT GUIDE</span>
        </div>
        <div class="header-sub-title">
          <span>{{ `Manage Product ${tabSelect}` }}</span>
        </div>
      </div>
      <div class="" v-loading="flagLoading.retrieve">
        <el-tabs tab-position="left" v-model="tabSelect">
          <el-tab-pane label="Content" name="Content">
            <EditorTipTap :actionItem="guides.content.content" actionType="content" @updateContent="updateContent" />
          </el-tab-pane>
          <el-tab-pane label="Players" name="Players">
            <EditorTipTap :actionItem="guides.content.players" actionType="players" @updateContent="updateContent" />
          </el-tab-pane>
          <el-tab-pane label="Audio" name="Audio">
            <EditorTipTap :actionItem="guides.content.audio" actionType="audio" @updateContent="updateContent" />
          </el-tab-pane>
          <el-tab-pane label="Integrate" name="Integrate">
            <EditorTipTap :actionItem="guides.content.integrate" actionType="integrate" @updateContent="updateContent" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="guides-actions">
        <el-button size="small" class="el-btn-blue" @click="updateSettings" :loading="flagLoading.update">SAVE CHANGES</el-button>
        <el-button size="small" @click="returnBack">CANCEL</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import EditorTipTap from '@/components/editors/Tiptap'
import { reactive } from 'vue'
export default {
  name: 'GlobalGuides',
  components: {
    EditorTipTap
  },
  data () {
    const flagLoading = reactive({
      retrieve: false,
      update: false
    })
    return {
      tabSelect: 'Content',
      guides: { type: 'guide', content: {} },
      content: {},
      flagLoading
    }
  },
  created () {
    this.getSettings()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getSettings: function () {
      if (this.flagLoading.retrieve) return
      this.flagLoading.retrieve = true
      const url = `/api/v1/atk_player/admin/settings/${this.guides.type}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.guides = res.data
          that.content = { ...res.data.content }
        } else {
          console.error('getSettings', res.msg)
        }
        that.flagLoading.retrieve = false
      }).catch(function (err) {
        console.error('getSettings', err.msg)
        that.flagLoading.retrieve = false
      })
    },
    updateSettings: function () {
      if (this.flagLoading.update) return
      this.flagLoading.update = true
      const url = `/api/v1/atk_player/admin/settings/${this.guides.type}`
      const body = { content: { ...this.content } }
      const that = this
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          console.error('updateSettings', res.msg)
        }
        that.flagLoading.update = false
      }).catch(function (err) {
        console.error('updateSettings', err.msg)
        that.flagLoading.update = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    updateContent: function (type, content) {
      this.content[type] = content
    }
  }
}
</script>

<style scoped>
.guides-actions {
  margin-top: 30px;
  padding-left: 105px;
}
</style>
